export default __webpack_public_path__ + "static/media/finance-logo-1.13610ae1.svg";